/**
 * Operations on lists of parameter configs and values
 */
import {AnalyticsParameterValue} from 'insights/parameters/__generated/AnalyticsParameterValue';
import getParameterValueObject from 'insights/parameters/data/getParameterValueObject';
import {JSONValue} from 'util/Types';

import {AnalyticsParameterConfigGraphQL} from '../../../../graphql-fragments/insights/__generated/AnalyticsParameterConfigGraphQL';

export function updateConfig(
  oldConfigs: Array<AnalyticsParameterConfigGraphQL>,
  updatedConfig: AnalyticsParameterConfigGraphQL
): Array<AnalyticsParameterConfigGraphQL> {
  return oldConfigs.map((config) => (config.id === updatedConfig.id ? updatedConfig : config));
}

export function updateValueJsonForConfig(
  configs: Array<AnalyticsParameterConfigGraphQL>,
  oldValues: Array<AnalyticsParameterValue>,
  configId: string,
  valueJson: JSONValue
): Array<AnalyticsParameterValue> {
  const matchingConfig = configs.find((config) => config.id === configId) as AnalyticsParameterConfigGraphQL;
  const matchingValue = oldValues.find((value) => value.config.id === configId);

  if (matchingValue) {
    // If matching value (for config) present, update it in place
    return oldValues.map((value) => (value === matchingValue ? {...matchingValue, valueJson} : value));
  }
  // If missing, create and append it
  return [...oldValues, getParameterValueObject(matchingConfig, valueJson)];
}
